<script setup>
import { computed, ref } from "vue";
import { formatDate } from "../../../helpers/date";
import Icon from "../../Common/Icon.vue";
import RenameCollection from "../Modal/RenameCollection.vue";
import { useModal } from "vue-final-modal";
import DeleteCollection from "../Modal/DeleteCollection.vue";
import { useI18n } from "vue-i18n";

const emit = defineEmits(["delete", "apply", "rename"]);

const { t } = useI18n();

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
});

function formatFilterRows(filters) {
  let rows = [];

  for (const filter in filters) {
    const value = filters[filter];

    if (!value) {
      continue;
    }

    if (filter === "dateFrom") {
      rows.push(`<p>ab ${formatDate(value, "Do MM. YYYY")}</p>`);
      continue;
    }

    if (filter === "dateTo") {
      rows.push(`<p>bis ${formatDate(value, "Do MM. YYYY")}</p>`);
      continue;
    }

    if (["categories", "persons", "locations"].includes(filter)) {
      if (value.length === 0) {
        continue;
      }

      rows.push("<p>" + t(`filter.group.${filter}`) + ` (${value.length})` + "</p>");

      const names = value.map((item) => item.name);
      rows.push(`<p class="text-12 lg:text-16 !mt-0">${names.join(", ")}</p>`);

      continue;
    }

    throw new Error(`Unable to format filter: ${filter} with value: ${value}`);
  }

  return rows.join("");
}

const formattedFilterRows = computed(() => {
  return formatFilterRows(props.item.filters);
});

const renameModal = useModal({
  component: RenameCollection,
  attrs: {
    collectionName: props.item.name,
    onClose() {
      renameModal.close();
    },
    onSubmit(e) {
      renameModal.close();
      window.klarnachrichten.trackMatomoEvent("collection-rename");
      emit("rename", e);
    },
  },
});

const deleteModal = useModal({
  component: DeleteCollection,
  attrs: {
    collectionName: props.item.name,
    onClose() {
      deleteModal.close();
    },
    onSubmit(e) {
      deleteModal.close();
      window.klarnachrichten.trackMatomoEvent("collection-delete");
      emit("delete");
    },
  },
});
</script>

<template>
  <div class="relative border-b border-dark/10 text-16 lg:text-20 isolate">
    <button
      type="button"
      class="group text-left w-full relative pr-20 lg:pr-28 pl-10 lg:pl-16 pt-8 pb-10"
      @click="emit('apply')"
    >
      <strong class="block font-medium mb-2" v-text="props.item.name"> </strong>
      <div class="space-y-2 text-dark/70 mb-4" v-html="formattedFilterRows"></div>
      <div
        class="text-primary font-medium text-16 flex items-center gap-x-3 group-hover:translate-x-2 transition-transform"
      >
        <span v-t="'filter.collection.apply'"></span>
        <Icon name="arrow" class="size-4 shrink-0" />
      </div>
    </button>

    <div class="absolute right-16 top-8 flex flex-col gap-y-1 z-10">
      <button type="button" class="p-2 text-dark/70 hover:text-primary transition-colors" @click="renameModal.open()">
        <Icon class="size-4 lg:size-5" name="edit" />
      </button>
      <button type="button" class="p-2 text-dark/70 hover:text-primary transition-colors" @click="deleteModal.open()">
        <Icon class="size-4 lg:size-5" name="garbage" />
      </button>
    </div>
  </div>
</template>
